import { Program } from '@coral-xyz/anchor'
import { PublicKey } from '@solana/web3.js'
import { getHedgeMintPublicKey, getPoolPublicKeyForMint, Vault } from 'hedge-web3'
import { StakingPool } from '../accounts/StakingPool'
import { StakingPoolPosition } from '../accounts/StakingPoolPosition'
import { HEDGE_PROGRAM_PUBLICKEY } from '../utils/HedgeConstants'

const LoadHedgeStakingPoolPositions = async (
  program: Program<Vault>,
  userWalletPublicKey: PublicKey
): Promise<StakingPoolPosition[]> => {
  if (!userWalletPublicKey) {
    return []
  }

  const hedgeMintPublicKey = await getHedgeMintPublicKey(HEDGE_PROGRAM_PUBLICKEY)
  const [hedgeStakingPoolPublicKey] = await getPoolPublicKeyForMint(HEDGE_PROGRAM_PUBLICKEY, hedgeMintPublicKey)
  const hedgeStakingPoolRaw = await program.account.stakingPool.fetch(hedgeStakingPoolPublicKey)
  const hedgeStakingPool = new StakingPool(hedgeStakingPoolRaw, hedgeStakingPoolPublicKey)

  const poolPositionsRaw = await program.account.stakingPoolPosition.all([
    // Filter on positions the user owns
    {
      memcmp: {
        bytes: userWalletPublicKey.toString(),
        offset: 8 + 16 * (128 * 2 + 2) + 8 * 4,
      },
    },
    // Filter on the hedge staking pool
    {
      memcmp: {
        bytes: hedgeStakingPoolPublicKey.toString(),
        offset: 8 + 16 * (128 * 2 + 2) + 8 * 4 + 32,
      },
    },
    // Filter on "Open" positions. 0 in the enum
    // {
    //   memcmp: {
    //     bytes: bs58.encode(Buffer.from([0])),
    //     offset: 8 + (16 * (128 * 2 + 2)) + (8 * 4) + 32 + 32
    //   },
    // },
  ])

  console.log('Staking pool Positions Raw', poolPositionsRaw)

  if (poolPositionsRaw.length > 1) {
    console.log('WARNING: User has more than one open HDG staking pool position.')
  }
  const poolPositions = poolPositionsRaw.map((position) => {
    console.log('Loaded Hedge Staking Position', position)
    return new StakingPoolPosition(position.account, position.publicKey, hedgeStakingPool)
  })
  return poolPositions
}

export default LoadHedgeStakingPoolPositions
